<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- SMALL loader for form content -->
  @if (showEntityLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showEntityLoader) {
<div>
    <table class="subTable custom-table">
      <tr>
        <th>LEID</th>
        <th>LE NAME</th>
        <th>EIN</th>
        <th>ADDRESS</th>
        <th>LE TYPE</th>
        <th>BUSINESS</th>
        <th>HO LEID</th>
        <th>HO TAX CODE</th>
        <th>HO REPORTING PERIOD</th>
        <th>STATE DOMICILE</th>
      </tr>
      @for (entity of gridData; track $index) {
<tr>
        <td>
          <input type="text" 
                 [value]="entity.data.LEID ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.LE_NAME ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.EIN ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.ADDRESS ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.LE_TYPE ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.ME_KEY ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.HO_LEID ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.HO_CDR_NO ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.HO_REPORTING_PERIOD ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
        <td>
          <input type="text" 
                 [value]="entity.data.STATE_DOMICILE ?? ''" 
                 class="form-control input-sm subtableRowHeight" 
                 disabled>
        </td>
      </tr>
}
    </table>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="delete-button" 
          type="button" 
          [disabled]="isLoading" 
          (click)="deleteEntity()">
    Delete Entity
    @if (isLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
